"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./base/colors.js"));

var border = {
  radius: {
    "default": 5,
    small: 2,
    large: 10,
    x_large: 20,
    xx_large: 28
  },
  width: {
    "default": 1,
    thin: 1,
    wide: 2,
    x_wide: 5
  }
};
var grid = {
  breakpoint: {
    small: 640,
    medium: 780,
    large: 980,
    xlarge: 1200
  }
};
var zindex = {
  modal: "1000",
  overlay: "900",
  tooltip: "800",
  notification: "700",
  dropdown: "600",
  navbarFixed: "501"
};
var XeThemeV1 = {
  heading: {
    font: {
      color: {
        "default": _colors["default"].blue["default"],
        fuscous: _colors["default"].grey.fuscous
      }
    }
  },
  link: {
    color: {
      "default": _colors["default"].blue.blueribbon,
      fuscous: _colors["default"].grey.fuscous
    },
    border: {
      tab: border.width.x_wide + "px" + " solid " + _colors["default"].blue.cornflower
    }
  },
  button: {
    backgroundColor: {
      "default": _colors["default"].white["default"],
      white: _colors["default"].white["default"],
      blue: _colors["default"].blue.endeavour,
      lightBlue: _colors["default"].blue.malibu,
      aquaBlue: _colors["default"].blue.aquablue,
      green: _colors["default"].green["default"],
      red: _colors["default"].red["default"],
      disabled: _colors["default"].grey.mercury,
      yellow: _colors["default"].yellow["default"],
      toggleon: _colors["default"].white["default"]
    },
    border: {
      radius: {
        "default": border.radius["default"] + "px",
        small: border.radius.small + "px",
        large: border.radius.large + "px",
        x_large: border.radius.x_large + "px",
        xx_large: border.radius.xx_large + "px"
      }
    },
    font: {
      color: {
        "default": _colors["default"].blue["default"],
        white: _colors["default"].blue["default"],
        blue: _colors["default"].white["default"],
        lightBlue: _colors["default"].white["default"],
        green: _colors["default"].white["default"],
        red: _colors["default"].white["default"],
        disabled: _colors["default"].grey.boulder,
        yellow: _colors["default"].blue["default"],
        toggleon: _colors["default"].yellow["default"]
      }
    },
    padding: {
      "default": "14px 10px",
      xSmall: "5px",
      small: "14px 10px",
      medium: "14px 10px",
      large: "14px 10px"
    },
    width: {
      "default": "200px",
      xSmall: "90px",
      small: "120px",
      medium: "200px",
      large: "320px"
    }
  },
  dropdown: {
    backgroundColor: {
      "default": _colors["default"].white["default"],
      white: _colors["default"].white["default"],
      blue: _colors["default"].blue["default"]
    },
    border: {
      radius: {
        "default": border.radius["default"] + "px",
        small: border.radius.small + "px",
        large: border.radius.large + "px"
      }
    }
  },
  siteheader: {
    backgroundColor: _colors["default"].blue.nightblue,
    background: _colors["default"].gradient["default"],
    width: "100%",
    mainNav: {
      zindex: zindex.navbarFixed,
      padding: "10px",
      height: "73px",
      width: "910px",
      backgroundColor: {
        "default": _colors["default"].transparent["default"],
        fallback: _colors["default"].blue.endeavour,
        hover: _colors["default"].yellow.hover,
        white: _colors["default"].white["default"]
      },
      font: {
        color: {
          "default": _colors["default"].white["default"],
          hover: _colors["default"].yellow.hover
        }
      },
      outline: {
        color: _colors["default"].white["default"],
        style: "auto",
        width: border.width.thin + "px"
      }
    },
    breadcrumb: {
      height: "36px"
    },
    menuButton: {
      backgroundColor: {
        "default": _colors["default"].transparent["default"],
        hover: _colors["default"].yellow.hover,
        white: _colors["default"].white["default"]
      },
      border: {
        color: {
          left: _colors["default"].grey.fuscous,
          right: _colors["default"].grey.silver
        },
        width: {
          thin: border.width.thin + "px",
          x_wide: border.width.x_wide + "px"
        }
      },
      font: {
        color: {
          "default": _colors["default"].white["default"],
          black: _colors["default"].black["default"],
          grey: _colors["default"].grey.fuscous,
          hover: _colors["default"].yellow.hover,
          blue: _colors["default"].blue["default"]
        }
      }
    }
  }
};
var _default = XeThemeV1;
exports["default"] = _default;